
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class CampaignSetupGrid extends Serenity.EntityGrid<CampaignSetupRow, any> {
        protected getColumnsKey() { return 'Administration.CampaignSetup'; }
        protected getDialogType() { return CampaignSetupDialog; }
        protected getIdProperty() { return CampaignSetupRow.idProperty; }
        protected getInsertPermission() { return CampaignSetupRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignSetupRow.localTextPrefix; }
        protected getService() { return CampaignSetupService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}